export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    add: 'Add',
    remove: 'Remove',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    noResults: 'No results found',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    actions: 'Actions',
    status: 'Status',
    priority: 'Priority',
    date: 'Date',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    description: 'Description',
    notes: 'Notes',
    attachments: 'Attachments',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    createdBy: 'Created by',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    none: 'None',
    required: 'Required',
    optional: 'Optional',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Information',
    close: 'Close',
    open: 'Open',
    view: 'View',
    details: 'Details',
    submit: 'Submit',
    send: 'Send',
    reset: 'Reset',
    clear: 'Clear',
    copy: 'Copy',
    download: 'Download',
    upload: 'Upload',
    export: 'Export',
    import: 'Import',
    refresh: 'Refresh',
    more: 'More',
    less: 'Less',
    showAll: 'Show all',
    hideAll: 'Hide all',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    noData: 'No data',
    emptyState: 'No items to display',
    active: 'Active',
    inactive: 'Inactive',
    you: 'You',
    time: 'Time',
  },

  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot password?',
    resetPasswordTitle: 'Reset password',
    resetPassword: {
      title: 'Reset password',
      subtitle: 'Enter your new password',
      newPassword: 'New password',
      submit: 'Reset password',
      invalidCode: 'The reset link is not valid.',
      expiredCode: 'The reset link has expired. Please request a new one.',
      successMessage: 'Your password has been reset successfully. You can now log in.',
      genericError: 'Error resetting password. Please try again.',
      requestNewLink: 'Request new link',
    },
    rememberMe: 'Remember me',
    signInWithGoogle: 'Sign in with Google',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    createAccount: 'Create account',
    welcomeBack: 'Welcome back',
    welcomeNew: 'Welcome to Torcaza Projects',
    loginSubtitle: 'Enter your credentials to access',
    registerSubtitle: 'Create your account to get started',
    invalidCredentials: 'Invalid credentials',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordMismatch: 'Passwords do not match',
    emailInvalid: 'Email is not valid',
    resetEmailSent: 'A password reset email has been sent',
    companyName: 'Company name',
    fullName: 'Full name',
  },

  navigation: {
    dashboard: 'Dashboard',
    home: 'Home',
    crm: 'CRM',
    commercial: 'Commercial',
    pipeline: 'Pipeline',
    prospects: 'Prospects',
    clients: 'Clients',
    organizations: 'Organizations',
    myOrganization: 'My Organization',
    projects: 'Projects',
    requirements: 'Requirements',
    releases: 'Releases',
    petitions: 'Petitions',
    tickets: 'Tickets',
    quotations: 'Quotations',
    salesOrders: 'Sales Orders',
    appointments: 'Appointments',
    users: 'Users',
    settings: 'Settings',
    activityLog: 'Activity Log',
    profile: 'Profile',
    notifications: 'Notifications',
    backlog: 'Backlog',
    sprintBoard: 'Sprint Board',
    management: 'Management',
    applications: 'Applications',
    implementations: 'Implementations',
  },

  dashboard: {
    welcome: 'Welcome, {name}',
    overview: 'Overview',
    recentActivity: 'Recent activity',
    activeProjects: 'Active projects',
    openTickets: 'Open tickets',
    pendingRequirements: 'Pending requirements',
    upcomingAppointments: 'Upcoming appointments',
    salesPipeline: 'Sales pipeline',
    projectsOverview: 'Projects overview',
    ticketsOverview: 'Tickets overview',
    totalUsers: 'Total users',
    totalSales: 'Total sales',
    totalProducts: 'Total products',
    quickActions: 'Quick actions',
    newTicket: 'New ticket',
    newRequirement: 'New requirement',
    scheduleAppointment: 'Schedule appointment',
    requestQuotation: 'Request quotation',
  },

  users: {
    title: 'Users',
    subtitle: 'Manage system users',
    createUser: 'Create user',
    newUser: 'New user',
    editUser: 'Edit user',
    deleteUser: 'Delete user',
    createUserDescription: 'Fill in the details to create a new user',
    editUserDescription: 'Modify user details',
    deleteConfirm: 'Are you sure you want to delete this user?',
    deleteConfirmTitle: 'Delete user',
    deleteConfirmMessage: 'Are you sure you want to delete {name}? This action cannot be undone.',
    role: 'Role',
    selectRole: 'Select role',
    organization: 'Organization',
    selectOrganization: 'Select organization',
    active: 'Active',
    inactive: 'Inactive',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activeStatus: 'Active status',
    activeStatusDescription: 'Inactive users cannot log in',
    lastLogin: 'Last login',
    noUsers: 'No users registered',
    searchPlaceholder: 'Search by name or email...',
    filterByRole: 'Filter by role',
    emailPlaceholder: "email{'@'}example.com",
    passwordPlaceholder: 'Minimum 6 characters',
    namePlaceholder: 'Full name',
    phonePlaceholder: '+1 234 567 8900',
    stats: {
      total: 'Total users',
      active: 'Active users',
      admins: 'Administrators',
      clients: 'Clients',
    },
    table: {
      user: 'User',
      role: 'Role',
      status: 'Status',
      createdAt: 'Created at',
    },
  },

  organizations: {
    title: 'Organizations',
    subtitle: 'Manage client organizations',
    newOrganization: 'New organization',
    editOrganization: 'Edit organization',
    deleteOrganization: 'Delete organization',
    deleteConfirm: 'Are you sure you want to delete this organization?',
    deleteConfirmTitle: 'Delete organization',
    deleteConfirmMessage: 'Are you sure you want to delete {name}? This action cannot be undone.',
    createDescription: 'Fill in the details to create a new organization',
    editDescription: 'Modify organization details',
    info: 'Information',
    industry: 'Industry',
    website: 'Website',
    address: 'Address',
    owner: 'Owner',
    members: 'Members',
    membersDescription: 'Users belonging to this organization',
    noOrganizations: 'No organizations registered',
    noMembers: 'No members in this organization',
    noOwner: 'No owner assigned',
    notFound: 'Organization not found',
    createdOn: 'Created on',
    inviteMember: 'Invite member',
    removeMember: 'Remove member',
    activeDescription: 'Inactive organizations cannot access the system',
    searchPlaceholder: 'Search by name or email...',
    namePlaceholder: 'Organization name',
    emailPlaceholder: "contact{'@'}company.com",
    phonePlaceholder: '+1 234 567 8900',
    addressPlaceholder: 'Company address',
    websitePlaceholder: 'https://www.company.com',
    notesPlaceholder: 'Additional notes...',
    stats: {
      total: 'Total organizations',
      active: 'Active',
      members: 'Total members',
    },
    table: {
      name: 'Organization',
      contact: 'Contact',
      members: 'Members',
      status: 'Status',
      createdAt: 'Created at',
    },
  },

  myOrganization: {
    subtitle: 'Your organization information',
    noOrganization: 'You do not belong to any organization',
    noOrganizationDescription: 'Contact your administrator to be added to an organization.',
    membersDescription: 'Members of your team',
  },

  crm: {
    title: 'CRM',
    pipeline: 'Pipeline',
    pipelineSubtitle: 'Manage your prospects and sales opportunities',
    prospects: 'Prospects',
    prospectsSubtitle: 'List of prospects and sales leads',
    newProspect: 'New prospect',
    editProspect: 'Edit prospect',
    deleteProspect: 'Delete prospect',
    deleteProspectConfirm: 'Are you sure you want to delete the prospect',
    companyName: 'Company name',
    contactName: 'Contact name',
    source: 'Source',
    stage: 'Stage',
    industry: 'Industry',
    estimatedValue: 'Estimated value',
    assignedTo: 'Assigned to',
    notes: 'Notes',
    convertToOrganization: 'Convert to organization',
    convertConfirm: 'Are you sure you want to convert this prospect to an organization?',
    convertDescription: 'A new organization will be created with the prospect data and the prospect will be marked as "Won".',
    noProspects: 'No prospects registered',
    notFound: 'Prospect not found',
    activities: 'Activities',
    logActivity: 'Log activity',
    activityType: 'Activity type',
    activityTitle: 'Activity title',
    duration: 'Duration',
    noActivities: 'No activities registered',
    time: 'Time',
    stages: {
      prospect: 'Prospect',
      contacted: 'Contacted',
      proposal_sent: 'Proposal Sent',
      negotiation: 'Negotiation',
      won: 'Won',
      lost: 'Lost',
    },
    activityTypes: {
      call: 'Call',
      email: 'Email',
      meeting: 'Meeting',
      note: 'Note',
    },
  },

  projects: {
    title: 'Projects',
    subtitle: 'Manage your development projects',
    newProject: 'New project',
    editProject: 'Edit project',
    deleteProject: 'Delete project',
    deleteConfirm: 'Are you sure you want to delete this project?',
    status: 'Status',
    organization: 'Organization',
    team: 'Team',
    operators: 'Assigned operators',
    startDate: 'Start date',
    endDate: 'End date',
    budget: 'Estimated budget',
    technologies: 'Technologies',
    repository: 'Repository',
    productionUrl: 'Production URL',
    stagingUrl: 'Staging URL',
    documents: 'Documents',
    noProjects: 'No projects registered',
    statuses: {
      definition: 'Definition',
      in_development: 'In Development',
      qa: 'QA',
      uat: 'UAT',
      production: 'Production',
      maintenance: 'Maintenance',
      completed: 'Completed',
      on_hold: 'On Hold',
    },
  },

  requirements: {
    title: 'Requirements',
    subtitle: 'Manage project requirements',
    newRequirement: 'New requirement',
    editRequirement: 'Edit requirement',
    deleteRequirement: 'Delete requirement',
    deleteConfirm: 'Are you sure you want to delete this requirement?',
    type: 'Type',
    priority: 'Priority',
    definitionStatus: 'Definition status',
    developmentStatus: 'Development status',
    estimatedHours: 'Estimated hours',
    effortPoints: 'Effort points',
    actualHours: 'Actual hours',
    assignedTo: 'Assigned to',
    release: 'Release',
    approve: 'Approve',
    reject: 'Reject',
    clientNotes: 'Client notes',
    internalNotes: 'Internal notes',
    noRequirements: 'No requirements registered',
    board: 'Board',
    list: 'List',
  },

  releases: {
    title: 'Releases',
    subtitle: 'Manage project releases',
    newRelease: 'New release',
    editRelease: 'Edit release',
    deleteRelease: 'Delete release',
    deleteConfirm: 'Are you sure you want to delete this release?',
    name: 'Name',
    version: 'Version',
    status: 'Status',
    plannedDate: 'Planned date',
    deployedAt: 'Deployed at',
    releaseNotes: 'Release notes',
    requirements: 'Included requirements',
    noReleases: 'No releases registered',
  },

  tickets: {
    title: 'Tickets',
    subtitle: 'Manage support tickets and inquiries',
    newTicket: 'New ticket',
    editTicket: 'Edit ticket',
    deleteTicket: 'Delete ticket',
    deleteConfirm: 'Are you sure you want to delete this ticket?',
    ticketTitle: 'Title',
    organization: 'Organization',
    project: 'Project',
    type: 'Type',
    priority: 'Priority',
    status: 'Status',
    assignedTo: 'Assigned to',
    sla: 'SLA',
    responseTime: 'Response time',
    resolutionTime: 'Resolution time',
    respondedAt: 'Responded at',
    resolvedAt: 'Resolved at',
    convertToRequirement: 'Convert to requirement',
    noTickets: 'No tickets registered',
    slaStatus: {
      onTime: 'On time',
      atRisk: 'At risk',
      overdue: 'Overdue',
    },
  },

  quotations: {
    title: 'Quotations',
    subtitle: 'Manage quotations and requests',
    newQuotation: 'New quotation',
    editQuotation: 'Edit quotation',
    deleteQuotation: 'Delete quotation',
    deleteConfirm: 'Are you sure you want to delete this quotation?',
    requestQuotation: 'Request quotation',
    projectName: 'Project name',
    projectType: 'Project type',
    hasDesigns: 'Has designs?',
    designsUrl: 'Designs URL',
    desiredDeadline: 'Desired deadline',
    estimatedBudget: 'Estimated budget',
    quotedAmount: 'Quoted amount',
    validUntil: 'Valid until',
    features: 'Features',
    convertToProject: 'Convert to project',
    noQuotations: 'No quotations registered',
    submitQuote: 'Submit quote',
    approve: 'Approve',
    reject: 'Reject',
    pending: 'Pending',
    quoted: 'Quoted',
    approved: 'Approved',
    rejected: 'Rejected',
    expired: 'Expired',
    internalNotes: 'Internal notes',
    rejectionReason: 'Rejection reason',
  },

  salesOrders: {
    title: 'Sales Orders',
    subtitle: 'Manage sales orders',
    newOrder: 'New order',
    editOrder: 'Edit order',
    deleteOrder: 'Delete order',
    deleteConfirm: 'Are you sure you want to delete this order?',
    orderNumber: 'Order number',
    status: 'Status',
    items: 'Items',
    subtotal: 'Subtotal',
    tax: 'Tax',
    taxRate: 'Tax rate',
    discount: 'Discount',
    total: 'Total',
    validUntil: 'Valid until',
    acceptedAt: 'Accepted at',
    noOrders: 'No orders registered',
    addItem: 'Add item',
    removeItem: 'Remove item',
    itemDescription: 'Description',
    quantity: 'Quantity',
    unitPrice: 'Unit price',
  },

  appointments: {
    title: 'Appointments',
    subtitle: 'Manage appointments and meetings',
    newAppointment: 'New appointment',
    editAppointment: 'Edit appointment',
    viewAppointment: 'View appointment',
    deleteAppointment: 'Delete appointment',
    deleteConfirm: 'Are you sure you want to delete this appointment?',
    requestAppointment: 'Request appointment',
    titleLabel: 'Title',
    type: 'Type',
    status: 'Status',
    requestedDateTime: 'Requested date/time',
    proposedDateTimes: 'Proposed date/times',
    confirmedDateTime: 'Confirmed date/time',
    meetingUrl: 'Meeting URL',
    assignedTo: 'Assigned to',
    proposeTimes: 'Propose times',
    confirmAppointment: 'Confirm appointment',
    noAppointments: 'No appointments registered',
    types: {
      initial_contact: 'Initial Contact',
      project_review: 'Project Review',
      demo: 'Demo',
      support: 'Support',
      other: 'Other',
    },
  },

  comments: {
    title: 'Comments',
    newComment: 'New comment',
    editComment: 'Edit comment',
    deleteComment: 'Delete comment',
    deleteConfirm: 'Are you sure you want to delete this comment?',
    internal: 'Internal comment',
    internalComment: 'Internal comment (only visible to the team)',
    internalHint: 'Only visible to the team',
    noComments: 'No comments',
    beFirst: 'Be the first to comment',
    addComment: 'Add comment',
    placeholder: 'Write your comment...',
    shortcut: 'Press Ctrl+Enter to send',
  },

  activityLog: {
    title: 'Activity Log',
    subtitle: 'Record of changes and actions',
    action: 'Action',
    entity: 'Entity',
    user: 'User',
    date: 'Date',
    changes: 'Changes',
    noLogs: 'No activity records',
    actions: {
      created: 'Created',
      updated: 'Updated',
      deleted: 'Deleted',
      status_changed: 'Status changed',
      assigned: 'Assigned',
      commented: 'Commented',
    },
  },

  settings: {
    title: 'Settings',
    subtitle: 'Configure system options',
    general: 'General',
    sla: 'SLA',
    slaSettings: {
      title: 'SLA Settings',
      subtitle: 'Define response and resolution times',
      priority: 'Priority',
      responseTime: 'Response time (hours)',
      resolutionTime: 'Resolution time (hours)',
    },
    theme: {
      title: 'Theme',
      light: 'Light',
      dark: 'Dark',
      system: 'System',
    },
    language: {
      title: 'Language',
      spanish: 'Spanish',
      english: 'English',
    },
  },

  profile: {
    title: 'Profile',
    subtitle: 'Manage your personal information and preferences',
    personalInfo: 'Personal information',
    personalInfoDesc: 'Update your name and contact details',
    displayName: 'Name',
    phonePlaceholder: '+1 555 123 4567',
    phoneInvalid: 'Only numbers, spaces, hyphens and + are allowed',
    phoneTooShort: 'Phone number is too short (minimum 7 digits)',
    phoneTooLong: 'Phone number is too long (maximum 15 digits)',
    saved: 'Saved successfully',
    preferences: 'Preferences',
    preferencesDesc: 'Customize the appearance and language of the application',
    themeDesc: 'Select the interface theme',
    languageDesc: 'Select the application language',
    security: 'Security',
    securityDesc: 'Change your password to keep your account secure',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    changePassword: 'Change password',
    passwordMinLength: 'Minimum 8 characters',
    passwordMinLengthHint: 'Minimum 8 characters',
    passwordMismatch: 'Passwords do not match',
    passwordChanged: 'Password updated successfully',
    wrongPassword: 'Current password is incorrect',
    samePassword: 'New password must be different from current',
    passwordChangeError: 'Error changing password',
    accountInfo: 'Account information',
    role: 'Role',
    memberSince: 'Member since',
  },

  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark all as read',
    noNotifications: 'You have no notifications',
    new: 'New',
  },

  petitions: {
    title: 'Petitions',
    subtitle: 'Manage your requests and petitions',
    newPetition: 'New Petition',
    editPetition: 'Edit Petition',
    deletePetition: 'Delete Petition',
    deleteConfirm: 'Are you sure you want to delete this petition?',
    withAIAssistant: 'With AI Assistant',
    quickForm: 'Quick Form',
    statuses: {
      requested: 'Requested',
      analyzing: 'Analyzing',
      feedback: 'Waiting for Info',
      costing: 'Costing',
      presented: 'Presented',
      approved: 'Approved',
      rejected: 'Rejected',
      converted: 'Converted',
    },
    categories: {
      new_feature: 'New Feature',
      improvement: 'Improvement',
      bug_report: 'Bug Report',
      change_request: 'Change Request',
      support: 'Support',
      other: 'Other',
    },
  },

  aiChat: {
    title: 'AI Assistant',
    subtitle: 'I help you define your petition',
    welcome: 'Welcome to the AI Assistant',
    welcomeMessage: 'Tell me what you need and I will help you create a clear and well-structured petition for the development team.',
    suggestions: 'You can tell me things like:',
    suggestion1: 'I need to add a new feature for...',
    suggestion2: 'There is a problem with...',
    suggestion3: 'I would like to improve...',
    generateDraft: 'Generate Draft',
    generatedByAI: 'Generated by AI',
    placeholder: 'Write your message...',
    sendHint: 'Press Enter to send, Shift+Enter for new line',
    errorSending: 'Error sending message',
    errorGenerating: 'Error generating draft',
    sessionLimit: 'Message limit reached',
    dailyLimit: 'Daily message limit reached',
    formPanel: {
      title: 'Petition Form',
      subtitle: 'Review and submit your request',
    },
  },

  backlog: {
    title: 'Backlog',
    subtitle: 'All requirements from all projects',
    tabBacklog: 'Backlog',
    tabSprints: 'Sprints',
    board: 'Board',
    newSprint: 'New Sprint',
    editSprint: 'Edit Sprint',
    newSprintDescription: 'Create a new sprint to organize work',
    editSprintDescription: 'Modify sprint details',
    sprintNamePlaceholder: 'Sprint 1',
    goal: 'Goal',
    goalPlaceholder: 'Sprint goal...',
    startDate: 'Start date',
    endDate: 'End date',
    selectSprint: 'Select sprint',
    noSprints: 'No sprints created',
    noSprintSelected: 'No sprint selected',
    selectSprintHint: 'Select a sprint to view its board',
    items: 'items',
    selected: 'selected',
    assign: 'Assign',
    assignToSprint: 'Assign to Sprint',
    removeFromSprint: 'Remove from Sprint',
    project: 'Project',
    startSprint: 'Start Sprint',
    completeSprint: 'Complete Sprint',
    cancelSprint: 'Cancel Sprint',
    confirmStartTitle: 'Start Sprint',
    confirmStartDescription: 'Starting the sprint will mark it as active. Only one sprint can be active at a time.',
    confirmCompleteTitle: 'Complete Sprint',
    confirmCompleteDescription: 'Requirements that did not reach production will return to the backlog without a sprint assigned.',
    confirmCancelTitle: 'Cancel Sprint',
    confirmCancelDescription: 'All requirements will be removed from the sprint and return to the backlog.',
    daysRemaining: 'days remaining',
    endsToday: 'Ends today',
    overdue: 'Overdue',
    velocity: 'Velocity',
    averageVelocity: 'Average velocity',
    filters: {
      project: 'Project',
      type: 'Type',
      priority: 'Priority',
      sprint: 'Sprint',
      devStatus: 'Dev Status',
      defStatus: 'Def Status',
      noSprint: 'No Sprint',
    },
  },

  errors: {
    generic: 'An error has occurred',
    notFound: 'Not found',
    unauthorized: 'Unauthorized',
    forbidden: 'Access denied',
    serverError: 'Server error',
    networkError: 'Connection error',
    validationError: 'Validation error',
    requiredField: 'This field is required',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone',
    invalidUrl: 'Invalid URL',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
    minValue: 'Minimum value: {min}',
    maxValue: 'Maximum value: {max}',
    invalidDate: 'Invalid date',
    futureDateRequired: 'Date must be in the future',
  },

  confirmations: {
    delete: 'Are you sure you want to delete this item?',
    unsavedChanges: 'You have unsaved changes. Do you want to leave anyway?',
    logout: 'Are you sure you want to log out?',
  },

  implementations: {
    title: 'Implementaciones',
    subtitle: 'Manage implementations',
    empty: 'No implementations found',
    emptyDesc: 'Create your first implementation to organize deployments',
    errors: {
      fetchAll: 'Error fetching implementations',
      fetchOne: 'Error fetching the implementation',
      create: 'Error creating the implementation',
      update: 'Error updating the implementation',
    },
  },

  timelineEvents: {
    title: 'History & Events',
    addEvent: 'Add Event',
    editEvent: 'Edit Event',
    empty: 'No events in history',
    emptyDesc: 'Log milestones, meetings or important updates',
    types: {
      milestone: 'Milestone',
      meeting: 'Meeting',
      release: 'Release',
      note: 'Note',
      update: 'Update',
      incident: 'Incident'
    },
    status: {
      planned: 'Planned',
      completed: 'Completed',
      cancelled: 'Cancelled'
    }
  },
}
